import DxButton from "devextreme-vue/button";
import DxCheckBox from "devextreme-vue/check-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import DxValidator, { DxRequiredRule } from "devextreme-vue/validator";
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxBox, DxItem } from 'devextreme-vue/box'


import { authService } from '../../../services/auth.service';
import { masterService } from '../../../services/master.service';
import { workerService } from '../../../services/worker.service';

import notify from 'devextreme/ui/notify'

export default {
  name: "login",
  data() {
    return {
      visibleLoadPanel: false,
      visibleTermsPopup: false,

      title: process.env.VUE_APP_PROJECT_NAME,
      login: "",
      password: "",
      rememberUser: false,
      passwordMode: 'password',
      passwordButton: {
        icon: 'key',
        type: 'default',
        onClick: () => {
          this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
        }
      },
    };
  },
  created() {
    if (this.$cookies.isKey("username")) {
      this.login = this.$cookies.get("username");
    }
    if (this.$cookies.isKey("password")) {
      this.password = this.$cookies.get("password");
    }
    if (this.$cookies.isKey("rememberUser")) {
      this.rememberUser = (Boolean)(this.$cookies.get("rememberUser"));
    }
  },
  methods: {
    onLoginClick(e) {

      if (!e.validationGroup.validate().isValid) return;

      this.visibleLoadPanel = true

      let self = this

      authService.login(this.login, this.password)
        .then(
          success => {
            if (success.messageType == 1) {

              self.$store.commit({
                type: 'setToken',
                token: success.content.token
              })

              let locations = success.content.locations;
              self.$store.commit({
                type: 'setLocations',
                locations: locations
              })

              // cookie保存
              if (self.rememberUser != false) {
                self.$cookies.set('username', self.login, process.env.VUE_APP_COOKIES_LIFETIME);
                self.$cookies.set('password', self.password, process.env.VUE_APP_COOKIES_LIFETIME);
                self.$cookies.set('rememberUser', self.rememberUser, process.env.VUE_APP_COOKIES_LIFETIME)
              } else {
                if (self.$cookies.isKey("rememberUser")) {
                  self.$cookies.remove("rememberUser");
                }
                if (self.$cookies.isKey("username")) {
                  self.$cookies.remove("username");
                }
                if (self.$cookies.isKey("password")) {
                  self.$cookies.remove("password");
                }
              }

              if (locations.length == 1) {
                self.$store.commit({
                  type: 'setCurrentLocation',
                  currentLocation: locations[0],
                })
                self.getWorker(self, e);
              } else {
                  self.$router.push({
                  path: "/select-location",
                  query: { redirect: this.$route.query.redirect },
                });
              }
            } else {
              self.visibleLoadPanel = false

              self.showMessage(success.message, 'error');
            }
          },
          error => {
            self.visibleLoadPanel = false

            console.log(error)
          }
        );
    },
    onClickForgotPassword() {
      this.visibleTermsPopup = true;
    },
    onClickNotAgree() {
      this.visibleTermsPopup = false;
    },
    onClickAgree() {
      this.$router.push({name: "forgot-password-form"});
    },
    getWorker(self, e) {
      workerService.getWorker()
        .then(
          success => {
            if (success.messageType == 1) {

              self.$store.commit(
                {
                  type: 'setWorker',
                  worker: success.content,
                })

              self.getConstant(self, e, success.content)
            } else {
              self.showMessage(success.message, 'error');

              self.$store.commit(
                {
                  type: 'logout',
                })

              self.visibleLoadPanel = false
            }
          },
          error => {
            self.visibleLoadPanel = false

            console.log(error)
          }
        );
    },
    getConstant(self, e, worker) {
      let promiseGetShiftChangeAutoMsg = masterService.getShiftChangeAutoMsg()
      let promiseGetWorkSheetLimitDays = masterService.getWorkSheetLimitDays(worker.fcId)
      let promiseGetShiftChangeLimitDays = masterService.getShiftChangeLimitDays(worker.fcId)
      let promiseGetDesiredShiftMsg = masterService.getDesiredShiftMsg(worker.fcId)
      let promiseGetWorkerNumbers = masterService.getWorkerNumbers(worker.locationId)
      let promiseGetAppUpdateUserId = masterService.getAppUpdateUserId()
      let promiseGetWorksheetTimeUnit = masterService.getWorksheetTimeUnit(worker.locationId)

      Promise.all(
        [promiseGetShiftChangeAutoMsg
          , promiseGetWorkSheetLimitDays
          , promiseGetShiftChangeLimitDays
          , promiseGetDesiredShiftMsg
          , promiseGetWorkerNumbers
          , promiseGetAppUpdateUserId
          , promiseGetWorksheetTimeUnit
        ])
        .then((results) => {

          if (results[0].messageType == 1
            && results[1].messageType == 1
            && results[2].messageType == 1
            && results[3].messageType == 1
            && results[4].messageType == 1
            && results[5].messageType == 1) {

            // storeに保存する
            self.$store.commit(
              {
                type: 'setConstantShiftChangeAutoMsg',
                shiftChangeAutoMsg: results[0].content.shiftChangeAutoMsg,
              })
            self.$store.commit(
              {
                type: 'setConstantWorkSheetLimitDays',
                closingTime: results[1].content.closingTime,
                maxOverTime: results[1].content.maxOverTime,
              })
            self.$store.commit(
              {
                type: 'setConstantShiftChangeLimitDays',
                shiftChangeLimitDays: results[2].content.shiftChangeLimitDay,
              })
            self.$store.commit(
              {
                type: 'setConstantDesiredShiftMsg',
                desiredShiftMsg: results[3].content.desiredShiftMsg,
                desiredShiftCode: results[3].content.desiredShiftCode,
              })
            self.$store.commit(
              {
                type: 'setConstantWorkerNumbers',
                workerNumbers: results[4].content.workNumbers,
              })
            self.$store.commit(
              {
                type: 'setConstantAppUpdateUserId',
                appUpdateUserId: results[5].content.appUpdateUserId,
              })
            self.$store.commit(
              {
                type: 'setWorksheetTimeUnit',
                worksheetTimeUnit: results[6].content,
              })

            // ホーム画面に遷移する
            self.$router.push(self.$route.query.redirect || "/home");

          } else {

            // エラーメッセージを表示する
            if (results[0].messageType == 0){
              self.showMessage(results[0].message, 'error');
            } else if (results[1].messageType == 0){
              self.showMessage(results[1].message, 'error');
            } else if (results[2].messageType == 0){
              self.showMessage(results[2].message, 'error');
            } else if (results[3].messageType == 0){
              self.showMessage(results[3].message, 'error');
            } else if (results[4].messageType == 0){
              self.showMessage(results[4].message, 'error');
            } else if (results[5].messageType == 0){
              self.showMessage(results[5].message, 'error');
            } 
          }

          self.visibleLoadPanel = false

          e.validationGroup.reset();
        }).catch((errors) => {

          self.visibleLoadPanel = false

          console.log(errors)
        })
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  components: {
    DxButton,
    DxCheckBox,
    DxTextBox,
    DxTextBoxButton,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup,
    DxLoadPanel,
    DxPopup,
    DxScrollView,
    DxBox,
    DxItem
  }
};